// composables/useModalStore.ts
import { Component, Ref } from "vue";
import { DialogController } from "./dialog-controller";

type ModalEntry = {
  id: number;
  title?: string;
  component: Component;
  props?: Record<string, unknown>;
  listeners?: Record<string, Function>;
  controller: DialogController;
  close: () => void;
  showHeader?: boolean;
  allowClose?: boolean;
};

let idCounter = 0;

export const useModalStore = () => {
  const modals = useState<ModalEntry[]>("modal-stack", () => []);

  function openModal({
    title,
    component,
    props,
    listeners,
    controller,
    showHeader,
    allowClose,
  }: {
    title?: string;
    component: Component;
    props: Record<string, unknown>;
    listeners?: Record<string, Function>;
    controller: DialogController;
    showHeader?: boolean;
    allowClose?: boolean;
  }) {
    const id = ++idCounter;

    const close = () => {
      const index = modals.value.findIndex((m) => m.id === id);
      if (index !== -1) modals.value.splice(index, 1);
    };

    modals.value.push({
      id,
      title,
      component: markRaw(component),
      props,
      listeners,
      controller,
      close,
      showHeader: showHeader ?? true,
      allowClose: allowClose ?? true,
    });

    return { close };
  }

  return {
    modals,
    openModal,
  };
};
